export default __webpack_public_path__ + "static/our_place_in_space-bfd86c00be994fe8930d44c992d29cc8.jpg";